export const withTimeout = <T>(
  promise: Promise<T>,
  ms: number
): Promise<T | void> =>
  Promise.race([
    promise,
    new Promise<void>((resolve) => setTimeout(resolve, ms)),
  ]);
